exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n[dir] .search-results-page {\n        background-color: #f8f8f8;\n}\n", "", {"version":3,"sources":["/var/www/html/pages/_lang/directory/phone/_page.vue"],"names":[],"mappings":";AACA;QACQ,0BAA0B;CACjC","file":"_page.vue","sourcesContent":["\n[dir] .search-results-page {\n        background-color: #f8f8f8;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true,"minimize":false,"importLoaders":0,"alias":{"/assets":"/var/www/html/assets","/static":"/var/www/html/static"}}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-20813ec0","scoped":false,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./pages/_lang/directory/phone/_page.vue
// module id = ./node_modules/css-loader/index.js?{"sourceMap":true,"minimize":false,"importLoaders":0,"alias":{"/assets":"/var/www/html/assets","/static":"/var/www/html/static"}}!./node_modules/vue-loader/lib/style-compiler/index.js?{"vue":true,"id":"data-v-20813ec0","scoped":false,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./pages/_lang/directory/phone/_page.vue
// module chunks = 26